import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'
import { paymentEntitiesQuery } from '@b-stock/fe-core/bstock-next/queries'

import useAccountId from '@/buyer-portal/helpers/useAccountId'
import { FeatureFlags } from '@/helpers/featureFlags'

const usePaymentEntitiesQuery = ({
  enabled = true,
  allStatuses = false,
}: { enabled?: boolean; allStatuses?: boolean } = {}) => {
  const accountId = useAccountId()
  const autoPayEnforced = useFlag(FeatureFlags.AUTOPAY_ENFORCED)

  // FF-on: fetch all methods (like checkout) so denied net terms show disabled state
  // FF-off (legacy): fetch only reusable
  // `allStatuses` bypasses the flag entirely (PAY-09: the My Account payment
  // methods page always needs every status so NetTerms denied/canceled/
  // suspended banners render regardless of the autopay flag).
  return paymentEntitiesQuery.useWithOpts(
    [
      {
        entityId: accountId ?? '',
        ...(allStatuses || autoPayEnforced ? {} : { status: 'reusable' }),
      },
    ],
    { enabled: enabled && !!accountId }
  )
}

export default usePaymentEntitiesQuery
